import { Component, Vue ,Prop } from 'vue-property-decorator';
import WithRender from './passwordreset.html';
import config from "@/settings/config.js";
import { PasswordResetDto,PasswordResetErrors } from './passwordresetdto';
import _axios from '@/services/axios';

@WithRender
@Component
export default class PasswordReset extends Vue  {

    password: string="";
    confirm:string="";
    
    hasErrored:boolean=false;
    validationErrors:string="";
    listErrors: PasswordResetErrors[] = [];

    @Prop({ default: Object as () => PasswordResetDto })
    forgotPassWordDto!: PasswordResetDto;
 
    sendPasswordReset() {
        this.resetChecks();
        this.validate();
        if(this.hasErrored)
            return;
        this.forgotPassWordDto.Password=this.password;
        this.getUrlParams();
        _axios.post(config.passwordreset, this.forgotPassWordDto).then(response => {
                     
        if(!this.errorCheck(response.data))
            this.$router.push("passwordresetsuccess");
                
        }).catch(error => { // (**)
            this.setValidationError("Ops something wrong has just happened please try again later, if the problem persists please drop us an email to info@umbai.co.za");
          });
    }

 private resetChecks():void{
     this.hasErrored=false;
     this.listErrors=[];
     this.validationErrors="";
 }
  private validate():void
  {
    if(this.password.length<4)
    {
      this.setValidationError("Password length should be more than 3 characters");
    }
    if(this.password!==this.confirm)
    { 
    this.setValidationError("Password should be equal to password confirm");
    }
  }

  private setValidationError(msg:string)
  {
    this.hasErrored=true;
    this.validationErrors=msg;
  }

   private getUrlParams():void
   {
    const queryString = window.location.search;
    const params =new URLSearchParams(queryString);
    this.forgotPassWordDto.UserId = params.get("UserId") as string;
    this.forgotPassWordDto.Token = params.get("Token") as string;
   } 

  private errorCheck(errors:PasswordResetErrors[]):boolean
    {
        if(errors.length>0)
         {
           this.hasErrored=true;
            this.listErrors =errors;
            return true;
         }
         return false;
    }
}
